import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { viewChecklist } from '../../new-rep-application-interfaces/checklist.interface';
import { viewAttachements } from '../../new-rep-application-interfaces/attachements.interface';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';
import { MatDialog } from '@angular/material/dialog';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { Router } from '@angular/router';
import { MnchecklistService } from '../../new-rep-application-services/mnchecklist/mnchecklist-service';
import { MnchecklistModel } from '../../new-rep-application-models/mnchecklist-models/mnchecklist-model';
import { noWhitespace } from '../../../../../shared/validators/no-whitespace.validator';

@Component({
  selector: 'app-fit-propercriteria',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIcon,
    MatSelectModule,
    MatButtonModule,
  ],
  templateUrl: './fit-propercriteria.component.html',
  styleUrl: './fit-propercriteria.component.scss'
})
export class FitPropercriteriaComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() fitandProperCriteria!: viewChecklist[];
  @Input() viewattachments!: viewAttachements[];
  @Input() bscgrade!: ViewNewRepApplication;
  @Input() readonly = signal(false);
  @Output() next = new EventEmitter<string[]>();
  @Output() preview = new EventEmitter<string[]>();
  @Output() save = new EventEmitter<string>();
  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  private mnchecklist = inject(MnchecklistService);
  setSprinner = signal(false);
  readonly message = 'This field is required.';
  status = 'Not Started';
  data = history.state;

  role = '';
  isVisible = signal(false)

  constructor() { }


  async ngOnInit(): Promise<void> {

    this.formGroup.addControl('fitPropercriteria_1', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_2', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_3', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_4', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_5', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_6', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_7', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_8', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('attachment8', this.fb.control(''));
    this.formGroup.addControl('attachment8_file', this.fb.control([null]));
    this.formGroup.addControl('fitPropercriteria_9', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_10', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('attachment10', this.fb.control(''));
    this.formGroup.addControl('attachment10_file', this.fb.control([null]));
    this.formGroup.addControl('fitPropercriteria_11', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_12', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_13', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_14', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_15', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_16', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_17', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_18', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_19', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_20', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_21', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_22', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_23', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_24', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_25', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_26', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_27', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('attachment27', this.fb.control(''));
    this.formGroup.addControl('attachment27_file', this.fb.control([null]));
    this.formGroup.addControl('fitPropercriteria_28', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('attachment28', this.fb.control(''));
    this.formGroup.addControl('attachment28_file', this.fb.control([null]));
    this.formGroup.addControl('fitPropercriteria_29', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_30', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_31', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_32', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_33', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteria_34', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('fitPropercriteriayes_33', this.fb.control(''));
    this.formGroup.addControl('quarteryear_1', this.fb.array(this.createArray()));
    this.formGroup.addControl('gradeRepresentative', this.fb.array(this.createArray()));
    this.formGroup.addControl('quarteryear_2', this.fb.array(this.createArray()));
    this.formGroup.addControl('gradeSupervisor', this.fb.array(this.createArray()));

    this.role = this.sessionStorageService.getCurrentUserRole();
    if ((this.role === 'DSU' || this.role === 'DSU Manager') && !this.fitandProperCriteria) {
      this.isVisible.set(true);
      this.getfitpropercriteria();
    }
    else {
      this.fetchFitproperCriteria();
    }
    this.handleFormStatus();
  }

  fetchFitproperCriteria(): void {
    this.formGroup.controls['fitPropercriteria_1']?.setValue(this.fitandProperCriteria[0]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_2']?.setValue(this.fitandProperCriteria[1]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_3']?.setValue(this.fitandProperCriteria[2]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_4']?.setValue(this.fitandProperCriteria[3]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_5']?.setValue(this.fitandProperCriteria[4]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_6']?.setValue(this.fitandProperCriteria[5]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_7']?.setValue(this.fitandProperCriteria[6]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_8']?.setValue(this.fitandProperCriteria[7]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_9']?.setValue(this.fitandProperCriteria[8]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_10']?.setValue(this.fitandProperCriteria[9]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_11']?.setValue(this.fitandProperCriteria[10]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_12']?.setValue(this.fitandProperCriteria[11]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_13']?.setValue(this.fitandProperCriteria[12]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_14']?.setValue(this.fitandProperCriteria[13]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_15']?.setValue(this.fitandProperCriteria[14]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_16']?.setValue(this.fitandProperCriteria[15]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_17']?.setValue(this.fitandProperCriteria[16]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_18']?.setValue(this.fitandProperCriteria[17]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_19']?.setValue(this.fitandProperCriteria[18]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_20']?.setValue(this.fitandProperCriteria[19]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_21']?.setValue(this.fitandProperCriteria[20]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_22']?.setValue(this.fitandProperCriteria[21]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_23']?.setValue(this.fitandProperCriteria[22]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_24']?.setValue(this.fitandProperCriteria[23]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_25']?.setValue(this.fitandProperCriteria[24]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_26']?.setValue(this.fitandProperCriteria[25]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_27']?.setValue(this.fitandProperCriteria[26]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_28']?.setValue(this.fitandProperCriteria[27]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_29']?.setValue(this.fitandProperCriteria[28]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_30']?.setValue(this.fitandProperCriteria[29]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_31']?.setValue(this.fitandProperCriteria[30]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_32']?.setValue(this.fitandProperCriteria[31]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_33']?.setValue(this.fitandProperCriteria[32]?.isCompleted);
    this.formGroup.controls['fitPropercriteria_34']?.setValue(this.fitandProperCriteria[33]?.isCompleted);
    this.viewattachments.forEach(item => {
      if (item?.onboardingDocumentType === 'fitPropercriteria_8') {
        this.formGroup.controls['attachment8']?.setValue(item?.fileName);
      } else if (item?.onboardingDocumentType === 'fitPropercriteria_10') {
        this.formGroup.controls['attachment10']?.setValue(item?.fileName);
      } else if (item?.onboardingDocumentType === 'fitPropercriteria_27') {
        this.formGroup.controls['attachment27']?.setValue(item?.fileName);
      } else if (item?.onboardingDocumentType === 'fitPropercriteria_28') {
        this.formGroup.controls['attachment28']?.setValue(item?.fileName);
      }
    })
    if (this.fitandProperCriteria[32]?.isCompleted == true) {
      this.formGroup.get('fitPropercriteriayes_33')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['fitPropercriteriayes_33']?.setValue(this.fitandProperCriteria[32]?.responseValue);
      this.formGroup.get('fitPropercriteriayes_33')?.markAsTouched();
    }

    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      const attachmentCategories = {
        fitPropercriteria_8: 'attachment8',
        fitPropercriteria_10: 'attachment10',
        fitPropercriteria_27: 'attachment27',
        fitPropercriteria_28: 'attachment28'
      };

      Object.entries(attachmentCategories).forEach(([category, controlName]) => {
        const latestDocument = this.viewattachments
          ?.filter(item => item?.onboardingDocumentType === category)
          ?.sort((a, b) => Number(b.id) - Number(a.id))[0];
        if (latestDocument) {
          this.formGroup.controls[controlName]?.setValue(
            latestDocument.fileName
          );
        }
      });

    }

    let quarteryear1 = this.bscgrade.bscGrade?.split(',');
    let gradeRepresentative = this.bscgrade.bscSatisfactory?.split(',');
    let quarteryear2 = this.bscgrade.bscGrade1?.split(',');
    let gradeSupervisor = this.bscgrade.bscSatisfactory1?.split(',');
    this.quarteryear_1.patchValue(quarteryear1);
    this.gradeRepresentative.patchValue(gradeRepresentative)
    this.quarteryear_2.patchValue(quarteryear2);
    this.gradeSupervisor.patchValue(gradeSupervisor);
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      const criteriaIds = [8, 10, 27, 28];

      const isIncomplete = criteriaIds.some(id => {
        const criteria = this.formGroup.get(`fitPropercriteria_${id}`)?.value;
        const attachment = this.formGroup.get(`attachment${id}`)?.value;

        return criteria && !attachment;
      });

      this.status = isIncomplete ? 'In Progress' : 'Completed';
      this.next.emit([this.status, 'submitted']);
    } else if (this.formGroup.invalid) {
      const anyFilled = Object.values(this.formGroup.value).some(v => {

        // null / undefined
        if (v === null || v === undefined) {
          return false;
        }

        // Array check
        if (Array.isArray(v)) {
          return v.some(item =>
            item !== null &&
            item !== undefined &&
            item.toString().trim() !== ''
          );
        }

        // String check
        if (typeof v === 'string') {
          return v.trim() !== '';
        }

        // Number / boolean
        return v !== '';
      });
      if (anyFilled) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'submitted']);
      } else {
        this.status = 'Not Started';
        this.next.emit([this.status, 'submitted']);
      }
    }
    if (this.readonly() == true) {
      this.formGroup?.disable();

    } else {
      this.formGroup?.enable();
    }
  }


  createArray() {
    return Array(8).fill(null).map(() => this.fb.control(''));
  }



  get quarteryear_1(): FormArray {
    return this.formGroup.get('quarteryear_1') as FormArray;
  }

  get gradeRepresentative(): FormArray {
    return this.formGroup.get('gradeRepresentative') as FormArray;
  }

  get quarteryear_2(): FormArray {
    return this.formGroup.get('quarteryear_2') as FormArray;
  }

  get gradeSupervisor(): FormArray {
    return this.formGroup.get('gradeSupervisor') as FormArray;
  }

  handleFormStatus() {
    // Nothing in a read-only section can be a user edit - the form is disabled.
    // Every emission here is programmatic: the saved data being loaded, and
    // disable() itself, which empties formGroup.value so it can never match the
    // baseline below. Each one overwrote the status the section had just derived
    // from that data, leaving a completed application reading "In Progress".
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  onCheckboxChange(checked: boolean, value: boolean, field: any) {
    if (checked) {
      this.formGroup.get(field)?.setValue(value);
      this.formGroup.get(field)?.markAsUntouched();
    } else {
      this.formGroup.get(field)?.setValue(null);
      this.formGroup.get(field)?.markAsTouched();
    }
  }

  onCheckboxChange1(checked: boolean, value: boolean, field: any, index: number) {
    if (checked) {
      this.formGroup.get(field)?.setValue(value);
      this.formGroup.get(field)?.markAsUntouched();
      if (this.formGroup.get(field)?.value == true) {
        if (index === 8 || index === 10 || index === 27 || index === 28) {
          this.formGroup.get('attachment' + index)?.setValidators([Validators.required]);

        } else if (index === 33) {
          this.formGroup.get('fitPropercriteriayes_' + index)?.setValidators([Validators.required, noWhitespace]);
        }

      } else {
        this.formGroup.get('attachment' + index)?.clearValidators();
        this.formGroup.get('attachment' + index)?.reset();
        this.formGroup.get('fitPropercriteriayes_' + index)?.clearValidators();
        this.formGroup.get('fitPropercriteriayes_' + index)?.reset();
      }
    } else {
      this.formGroup.get(field)?.setValue(null);
      this.formGroup.get(field)?.markAsTouched();
    }
  }

  onAttachmentFileChange(event: any, controlName: string, fileVar: string, categoryname: string): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const control = this.formGroup.get(controlName);

    // ✅ Valid file → update form properly
    this.formGroup.patchValue({
      [fileVar]: file,
      [controlName]: file?.name
    });

    if (!control) return;

    // Reset first
    control.markAsTouched();
    control.setErrors(null);

    if (!file) {
      control.setValue(null);
      return;
    }

    const allowedTypes = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png'
    ]);

    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate type
    if (!allowedTypes.has(file.type)) {
      control.setErrors({ invalidType: true });
      return;
    }

    // Validate size
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      return;
    }

    control.updateValueAndValidity();
    this.uploaddocument(fileVar, controlName, categoryname);
  }

  async uploaddocument(fileVar: string, controlName: string, categoryname: string) {

    const formData = new FormData();

    formData.append('file', this.formGroup.get(fileVar)?.value);
    formData.append('Description', categoryname);
    formData.append('filename', this.formGroup.get(fileVar)?.value?.name);
    formData.append('ResponseValue', '');
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      formData.append('UserId', String(this.data.applicant.onboardingid));
    }

    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.formGroup.patchValue({
        [controlName]: responseData.data.responsedata
      });
      if (this.role === 'DSU' || this.role === 'DSU Manager') {
        this.viewDsuDocuments();
      } else {
        this.viewDocumants();
      }

      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  async viewDocumants() {
    let id = Number(this.sessionStorageService.getCurrentUserId());
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(id)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.viewattachments = responseData.data.responsedata.attachments;
  }


  async viewDsuDocuments() {
    let repCode = this.data.applicant.repcode;
    const responseData = await this.mnchecklist
      .getmnchecklist(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewattachments = responseData.data.responsedata.documents;
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  removeFile(controlName: string, fileVar: string, categoryname: string) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      this.viewDsuDocuments();
    } else {
      this.viewDocumants();
    }
    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.viewattachments) {
          let onboardingId;
          let id;
          let docTypeId;
          if (this.role === 'DSU' || this.role === 'DSU Manager') {
            // this.viewattachments.forEach(item => {
            //   if (item?.onboardingDocumentType === categoryname && ['DSU', 'DSU Manager'].includes(item.updatedByRole)) {
            //     onboardingId = this.data.applicant.onboardingid;
            //     docTypeId = item.docTypeId;
            //     id = item.id
            //   }
            // })
            const latestDocument = this.viewattachments
              ?.filter(item => item?.onboardingDocumentType === categoryname && ['DSU', 'DSU Manager'].includes(item.updatedByRole))
              ?.sort((a, b) => Number(b.id) - Number(a.id))[0];
            if (latestDocument) {
              onboardingId = this.data.applicant.onboardingid;
              docTypeId = latestDocument.docTypeId;
              id = latestDocument.id;
            }
          } else {
            this.viewattachments.forEach(item => {
              if (item?.onboardingDocumentType === categoryname) {
                onboardingId = item.onboardingId;
                docTypeId = item.docTypeId;
                id = item.id
              }
            })
          }

          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id
          }
          if (id) {
            const responseData = await this.newRepApplicationService
              .deletedocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                // console.error(error);
                return error;
              });
          }
        }
        this.formGroup.get(controlName)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.formGroup.get(fileVar)?.reset();
        this.formGroup.controls[controlName].markAsTouched();
        this.formGroup.controls[controlName].updateValueAndValidity();
      } else {
        // console.log('User cancelled');
      }
    });
  }

  saveAndContinue() {

    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';

    }
    this.formGroup.markAllAsTouched();
    this.next.emit([this.status, 'submit']);
  }

  previewAttachment(controlName: string, categoryName: string) {
    if (this.viewattachments) {
      let id;
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === categoryName) {
          id = item.id;
        }
      });
      let filename = this.formGroup.get(controlName)?.value;
      this.preview.emit([id, filename]);
    }
  }
  async saveSection() {
    this.setSprinner.set(true);
    let savefitpropercriteria = new MnchecklistModel();
    savefitpropercriteria.setpias_rep_code(this.data.applicant.repcode);
    savefitpropercriteria.setmnChecklist([
      {
        id: this.fitandProperCriteria[0]?.id,
        question_id: this.fitandProperCriteria[0]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_1')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[1]?.id,
        question_id: this.fitandProperCriteria[1]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_2')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[2]?.id,
        question_id: this.fitandProperCriteria[2]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_3')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[3]?.id,
        question_id: this.fitandProperCriteria[3]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_4')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[4]?.id,
        question_id: this.fitandProperCriteria[4]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_5')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[5]?.id,
        question_id: this.fitandProperCriteria[5]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_6')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[6]?.id,
        question_id: this.fitandProperCriteria[6]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_7')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[7]?.id,
        question_id: this.fitandProperCriteria[7]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_8')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[8]?.id,
        question_id: this.fitandProperCriteria[8]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_9')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[9]?.id,
        question_id: this.fitandProperCriteria[9]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_10')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[10]?.id,
        question_id: this.fitandProperCriteria[10]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_11')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[11]?.id,
        question_id: this.fitandProperCriteria[11]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_12')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[12]?.id,
        question_id: this.fitandProperCriteria[12]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_13')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[13]?.id,
        question_id: this.fitandProperCriteria[13]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_14')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[14]?.id,
        question_id: this.fitandProperCriteria[14]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_15')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[15]?.id,
        question_id: this.fitandProperCriteria[15]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_16')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[16]?.id,
        question_id: this.fitandProperCriteria[16]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_17')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[17]?.id,
        question_id: this.fitandProperCriteria[17]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_18')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[18]?.id,
        question_id: this.fitandProperCriteria[18]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_19')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[19]?.id,
        question_id: this.fitandProperCriteria[19]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_20')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[20]?.id,
        question_id: this.fitandProperCriteria[20]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_21')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[21]?.id,
        question_id: this.fitandProperCriteria[21]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_22')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[22]?.id,
        question_id: this.fitandProperCriteria[22]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_23')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[23]?.id,
        question_id: this.fitandProperCriteria[23]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_24')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[24]?.id,
        question_id: this.fitandProperCriteria[24]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_25')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[25]?.id,
        question_id: this.fitandProperCriteria[25]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_26')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[26]?.id,
        question_id: this.fitandProperCriteria[26]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_27')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[27]?.id,
        question_id: this.fitandProperCriteria[27]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_28')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[28]?.id,
        question_id: this.fitandProperCriteria[28]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_29')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[29]?.id,
        question_id: this.fitandProperCriteria[29]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_30')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[30]?.id,
        question_id: this.fitandProperCriteria[30]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_31')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[31]?.id,
        question_id: this.fitandProperCriteria[31]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_32')?.value,
        response_value: '',
      },
      {
        id: this.fitandProperCriteria[32]?.id,
        question_id: this.fitandProperCriteria[32]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_33')?.value,
        response_value: this.formGroup.get('fitPropercriteriayes_33')?.value,
      },
      {
        id: this.fitandProperCriteria[33]?.id,
        question_id: this.fitandProperCriteria[33]?.questionId,
        is_completed: this.formGroup.get('fitPropercriteria_34')?.value,
        response_value: '',
      }
    ]);

    let bscGrade = String(this.formGroup.get('quarteryear_1')?.value);
    let bscSatisfactory = String(this.formGroup.get('gradeRepresentative')?.value);
    let bscGrade1 = String(this.formGroup.get('quarteryear_2')?.value);
    let bscSatisfactory1 = String(this.formGroup.get('gradeSupervisor')?.value);

    savefitpropercriteria.setBscGrade(bscGrade);
    savefitpropercriteria.setBscGrade1(bscGrade1);
    savefitpropercriteria.setBscSatisfactory(bscSatisfactory);
    savefitpropercriteria.setBscSatisfactory1(bscSatisfactory1);

    const responseData = await this.mnchecklist
      .postmnchecklist(savefitpropercriteria)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.save.emit('saved');
      this.getfitpropercriteria();

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }
  cancelSection() {
    this.save.emit('cancelled');
  }

  async getfitpropercriteria() {
    this.setSprinner.set(true);
    let repCode = this.data.applicant.repcode;

    const responseData = await this.mnchecklist
      .getmnchecklist(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {

      this.fitandProperCriteria = responseData.data.responsedata.check_list
        .filter((fit: viewChecklist) => fit.categoryName.includes('fitPropercriteria_'))
        .sort((a: any, b: any) => {
          const aIndex = Number(a.categoryName.split('_').pop());
          const bIndex = Number(b.categoryName.split('_').pop());
          return aIndex - bIndex;
        })
      this.viewattachments = responseData.data.responsedata.documents;
      this.bscgrade = responseData.data.responsedata.mn_bsc_grade[0];
      this.fetchFitproperCriteria();

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }
}



